"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddressSearch = void 0;
var _react = require("react");
var _useQuestionSelectionActions = require("./useQuestionSelectionActions");
var _productCatalogSelectors = require("../../store/productCatalog/productCatalogSelectors");
var _services = require("../../services");
var _productCatalogActions = require("../../store/productCatalog/productCatalogActions");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector2 = require("../useAppSelector");
var _CookiesManager = _interopRequireDefault(require("../../utils/CookiesManager"));
var _constants = require("../../utils/constants");
var _useConfig = _interopRequireDefault(require("../useConfig"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useAddressSearch = function (question, selections) {
  var _parsedSelection$name, _parsedSelection$name2, _parsedSelection$stre, _parsedSelection$stre2, _CookiesManager$getCo, _CookiesManager$getCo2, _CookiesManager$getCo3, _ref, _defaultSelection$add, _ref2, _defaultSelection$str, _ref3, _defaultSelection$str2, _useAppSelector;
  let checkAvailability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const cookies = (0, _useConfig.default)('cookies', null);
  const minCharacters = question.minCharacters;
  const selection = selections[0] || '';
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const parsedSelection = selection && JSON.parse(selection);
  const defaultSelection = parsedSelection && {
    address: checkAvailability ? (_parsedSelection$name = parsedSelection.name) === null || _parsedSelection$name === void 0 ? void 0 : (_parsedSelection$name2 = _parsedSelection$name.split(',')) === null || _parsedSelection$name2 === void 0 ? void 0 : _parsedSelection$name2[0] : parsedSelection.name,
    streetName: (_parsedSelection$stre = parsedSelection.streetName) === null || _parsedSelection$stre === void 0 ? void 0 : (_parsedSelection$stre2 = _parsedSelection$stre.split(' ')) === null || _parsedSelection$stre2 === void 0 ? void 0 : _parsedSelection$stre2[0],
    streetNumber: parsedSelection.selectedStreetNr,
    postcode: parsedSelection.postcode,
    postCodeInputType: parsedSelection.postCodeInputType
  };
  const cookieAddress = JSON.parse((_CookiesManager$getCo = _CookiesManager.default.getCookie({
    name: 'address',
    encoded: true
  })) !== null && _CookiesManager$getCo !== void 0 ? _CookiesManager$getCo : 'null');
  const cookieAddressMeta = JSON.parse((_CookiesManager$getCo2 = _CookiesManager.default.getCookie({
    name: 'addressMeta',
    encoded: true
  })) !== null && _CookiesManager$getCo2 !== void 0 ? _CookiesManager$getCo2 : 'null');
  const cookieAddressSource = JSON.parse((_CookiesManager$getCo3 = _CookiesManager.default.getCookie({
    name: 'addressSource',
    encoded: true
  })) !== null && _CookiesManager$getCo3 !== void 0 ? _CookiesManager$getCo3 : 'null');

  // Parse the selection and set default values for the address and postcode
  if (defaultSelection.postCodeInputType) {
    if (defaultSelection.postCodeInputType === 'number') {
      defaultSelection.address = defaultSelection.postcode;
    } else if (defaultSelection.postCodeInputType === 'mixed') {
      defaultSelection.address = defaultSelection.address + ' ' + defaultSelection.postcode;
    }
  }
  const [isAddressNoFoundError, setAddressNoFoundError] = (0, _react.useState)(false);
  const [isInvalidInputRule, setIsInvalidInputRule] = (0, _react.useState)(false);
  const [postCodeInputType, setPostCodeInputType] = (0, _react.useState)(defaultSelection.postCodeInputType);
  const [isCheckAvailabilityLoading, setCheckAvailabilityLoading] = (0, _react.useState)(false);
  // set the default values from the defaultSelection OR the cookie
  const [address, setAddress] = (0, _react.useState)((_ref = (_defaultSelection$add = defaultSelection.address) !== null && _defaultSelection$add !== void 0 ? _defaultSelection$add : cookieAddress === null || cookieAddress === void 0 ? void 0 : cookieAddress[cookieAddressMeta === null || cookieAddressMeta === void 0 ? void 0 : cookieAddressMeta.cityOrZipcode]) !== null && _ref !== void 0 ? _ref : '');
  const [streetName, setStreetName] = (0, _react.useState)((_ref2 = (_defaultSelection$str = defaultSelection.streetName) !== null && _defaultSelection$str !== void 0 ? _defaultSelection$str : cookieAddress === null || cookieAddress === void 0 ? void 0 : cookieAddress.street) !== null && _ref2 !== void 0 ? _ref2 : '');
  const [streetNumber, setStreetNumber] = (0, _react.useState)((_ref3 = (_defaultSelection$str2 = defaultSelection.streetNumber) !== null && _defaultSelection$str2 !== void 0 ? _defaultSelection$str2 : cookieAddress === null || cookieAddress === void 0 ? void 0 : cookieAddress.housenumber) !== null && _ref3 !== void 0 ? _ref3 : '');
  const addresses = (_useAppSelector = (0, _useAppSelector2.useAppSelector)(_productCatalogSelectors.selectAddressSuggestions)) !== null && _useAppSelector !== void 0 ? _useAppSelector : [];
  const addressError = (0, _useAppSelector2.useAppSelector)(_productCatalogSelectors.selectAddressError);
  const addressSuggestions = addresses.map(el => ({
    text: el.name
  }));
  const {
    replaceSelection,
    removeSelection
  } = (0, _useQuestionSelectionActions.useQuestionSelectionActions)(question);
  (0, _react.useEffect)(() => {
    if ((isInvalidInputRule || isCheckAvailabilityLoading) && selection) {
      removeSelection(selection);
    }
  }, [isInvalidInputRule, selection, isCheckAvailabilityLoading]);
  const addressDifferFromCookie = () => {
    return !cookieAddress || address !== cookieAddress[cookieAddressMeta === null || cookieAddressMeta === void 0 ? void 0 : cookieAddressMeta.cityOrZipcode] || streetName !== cookieAddress.street || streetNumber !== cookieAddress.housenumber;
  };
  (0, _react.useEffect)(() => {
    if (checkAvailability && addressDifferFromCookie()) {
      const isCompleteAddress = (address === null || address === void 0 ? void 0 : address.length) >= 2 && (streetName === null || streetName === void 0 ? void 0 : streetName.length) >= 2 && streetNumber;
      if (!address && !streetName && !streetNumber) dispatch((0, _productCatalogActions.clearAddressError)());
      if (!isCompleteAddress || isInvalidInputRule) return;
      const timeoutId = setTimeout(() => {
        setCheckAvailabilityLoading(true);
        dispatch((0, _productCatalogActions.fetchAddressSuggestions)([encodeURIComponent((0, _core.capitalize)(address.trim().toLowerCase())), encodeURIComponent(streetName.trim()), encodeURIComponent(streetNumber.trim())].join('/').trim(), cookies));
      }, 1000);
      return () => {
        setCheckAvailabilityLoading(false);
        clearTimeout(timeoutId);
      };
    }
    //if address is one of the suggestions from the api and the street number is an integer make the selection
    else if (!!addressSuggestions.find(suggestion => suggestion.text === address) && streetNumber) {
      replaceSelection(createSelection());
    }
    // if the values are set by the cookie, just enable the next button
    else if (cookieAddress && cookieAddressSource) {
      replaceSelection(JSON.stringify(cookieAddressSource));
      dispatch((0, _productCatalogActions.clearAddressError)());
    }
  }, [address, streetNumber, streetName, isInvalidInputRule]);
  (0, _react.useEffect)(() => {
    if (checkAvailability && addresses.length) {
      try {
        const userAddress = addresses === null || addresses === void 0 ? void 0 : addresses[0];
        if (!userAddress) {
          setAddressNoFoundError(true);
        } else {
          replaceSelection(createSelection({
            addressSelection: userAddress.name
          }));
          setAddressNoFoundError(false);
          setCheckAvailabilityLoading(false);
        }
      } catch (e) {
        console.log('Address Finder Error: ', e);
        removeSelection(selection);
        setAddressNoFoundError(true);
      }
    }
    const isEmptyAddress = !address && !streetName && !streetNumber;
    if (addressError && !isEmptyAddress) {
      removeSelection(selection);
      setCheckAvailabilityLoading(false);
      setAddressNoFoundError(true);
    } else setAddressNoFoundError(false);
  }, [addresses, addressError]);
  const onChange = value => {
    // need to know if the user entered a city or zipcode so that after we persist the cookie we will be able to
    // set the correct value (city or zipcode) to the address variable.
    let cityOrZipcode = _constants.ADDRESS_TYPE.ZIPCODE;
    if (isNaN(value)) {
      // user entered city
      cityOrZipcode = _constants.ADDRESS_TYPE.CITY;
    }
    _CookiesManager.default.setCookie({
      name: 'addressMeta',
      value: JSON.stringify({
        cityOrZipcode
      }),
      encoded: true
    });
    setAddress(value);
    if (/^\d+$/.test(value)) setPostCodeInputType('number');else if (/^[a-zA-Z]+$/.test(value)) setPostCodeInputType('text');else setPostCodeInputType('mixed');
    if (selection && value !== address) {
      removeSelection(selection);
    }
  };
  const createSelection = function () {
    let {
      addressSelection,
      numberSelection
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const searchAddressName = addressSelection || address;
    const addressObject = addresses.find(addressObject => {
      return addressObject.name === searchAddressName;
    });
    return JSON.stringify({
      ...addressObject,
      selectedStreetNr: numberSelection ? numberSelection : streetNumber,
      postCodeInputType
    });
  };
  const onStreetNumberChange = value => {
    setStreetNumber(value);
    if (selection && value !== streetNumber) {
      removeSelection(selection);
    }
  };
  const onStreetNameChange = value => {
    setStreetName(value);
    if (selection && value !== streetName) {
      removeSelection(selection);
    }
  };
  const onSelect = choice => {
    if (choice.hasEmptyResults) return;
    setAddress(choice.text);
  };
  const onFilter = async (value, regex) => {
    if (value) dispatch((0, _productCatalogActions.fetchAddressSuggestions)(value));
    return addressSuggestions !== null && addressSuggestions !== void 0 && addressSuggestions.length ? addressSuggestions.map(el => ({
      text: el.name
    })) : [{
      text: _services.locale.localeString('ErrorPage.AddressNotFound', {
        value: value
      }),
      hasEmptyResults: true
    }];
  };
  return {
    addressSuggestions,
    address,
    minCharacters,
    onChange,
    onStreetNumberChange,
    onSelect,
    onFilter,
    streetNumber,
    streetName,
    onStreetNameChange,
    isAddressNoFoundError,
    isCheckAvailabilityLoading,
    setIsInvalidInputRule,
    setPostCodeInputType
  };
};
exports.useAddressSearch = useAddressSearch;